/**
 * ProductAssetsTab V2
 *
 * Tab für Asset/Bilder Verwaltung.
 * 4 Sub-Tabs: Produktbilder | KI-Referenzen | KI-Assets | Bildersammlung
 *
 * Built with Tailwind CSS v4.1 and V2 components.
 * WCAG 2.1 Level AA + BFSG konform
 */

import { useState } from 'react';
import { Images, Sparkles, Bot, Archive } from 'lucide-react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/v2/ui';
import { ProductImagesSubTab } from './assets/ProductImagesSubTab';
import { AIReferencesSubTab } from './assets/AIReferencesSubTab';
import { AIAssetsSubTab } from './assets/AIAssetsSubTab';
import { ImageCollectionSubTab } from './assets/ImageCollectionSubTab';

type SubTab = 'product-assets' | 'ai-refs' | 'ai-assets' | 'image-collection';

interface ProductAssetsTabProps {
  productId: string;
}

export function ProductAssetsTab({ productId }: ProductAssetsTabProps) {
  const [activeSubTab, setActiveSubTab] = useState<SubTab>('product-assets');
  const [imageSize, setImageSize] = useState<'S' | 'M' | 'L'>('M');

  return (
    <div className="product-assets-tab">
      <Tabs value={activeSubTab} onValueChange={(value) => setActiveSubTab(value as SubTab)}>
        {/* Sub-Tab Navigation */}
        <TabsList className="mb-6">
          <TabsTrigger value="product-assets" className="flex items-center gap-2">
            <Images className="h-4 w-4" />
            Produktbilder
          </TabsTrigger>
          <TabsTrigger value="ai-refs" className="flex items-center gap-2">
            <Sparkles className="h-4 w-4" />
            KI-Referenzen
          </TabsTrigger>
          <TabsTrigger value="ai-assets" className="flex items-center gap-2">
            <Bot className="h-4 w-4" />
            KI-Assets
          </TabsTrigger>
          <TabsTrigger value="image-collection" className="flex items-center gap-2">
            <Archive className="h-4 w-4" />
            Bildersammlung
          </TabsTrigger>
        </TabsList>

        {/* Sub-Tab Content */}
        <TabsContent value="product-assets">
          <ProductImagesSubTab
            productId={productId}
            imageSize={imageSize}
            setImageSize={setImageSize}
          />
        </TabsContent>

        <TabsContent value="ai-refs">
          <AIReferencesSubTab productId={productId} />
        </TabsContent>

        <TabsContent value="ai-assets">
          <AIAssetsSubTab productId={productId} />
        </TabsContent>

        <TabsContent value="image-collection">
          <ImageCollectionSubTab productId={productId} />
        </TabsContent>
      </Tabs>
    </div>
  );
}
